module.exports = __webpack_public_path__ + "img/5.4c4f4459.png";